/*
 * Copyright (c) 2020. American Express Company
 */

import { RecurringExpenseModel } from 'src/types/recurring-expense.model';
import BWDataService from './bw-data.service';
import DateUtils from 'src/utils/date';

export default class RecurringExpenseService extends BWDataService {
    public static async createRecurringExpense(
        recurringExpenseToBeCreated: RecurringExpenseModel
    ): Promise<RecurringExpenseModel> {
        return await this.postRecurringExpense(recurringExpenseToBeCreated);
    }

    private static async postRecurringExpense(recurringExpense: RecurringExpenseModel): Promise<RecurringExpenseModel> {
        const payload: RecurringExpenseModel = {
            name: recurringExpense.name,
            monthlyAmount: recurringExpense.monthlyAmount,
            categories: recurringExpense.categories,
            groupUid: recurringExpense.groupUid,
            startDate: recurringExpense.startDate,
            endDate: recurringExpense.endDate
        };

        const newRecurringExpense = await this.post('/recurringexpenses', payload);
        newRecurringExpense.startDate = DateUtils.dateify(recurringExpense.startDate);
        newRecurringExpense.endDate = DateUtils.dateify(recurringExpense.endDate);

        return newRecurringExpense;
    }

    public static async getRecurringExpenses(): Promise<RecurringExpenseModel[]> {
        const recurringExpenses: RecurringExpenseModel[] = await this.get('/recurringexpenses');
        recurringExpenses?.forEach((recurringExpense) => {
            recurringExpense.startDate = DateUtils.dateify(recurringExpense.startDate);
            recurringExpense.endDate = DateUtils.dateify(recurringExpense.endDate);
        });
        return recurringExpenses;
    }

    public static async deleteRecurringExpense(recurringExpense: RecurringExpenseModel): Promise<number> {
        return await this.delete(`/recurringexpenses/${recurringExpense.id}`);
    }

    public static async updateRecurringExpense(recurringExpense: RecurringExpenseModel): Promise<void> {
        const payload: RecurringExpenseModel = {
            name: recurringExpense.name,
            monthlyAmount: recurringExpense.monthlyAmount,
            categories: recurringExpense.categories,
            startDate: recurringExpense.startDate,
            endDate: recurringExpense.endDate
        };

        await this.put(`/recurringexpenses/${recurringExpense.id}`, payload);
    }
}
